<template>
  <div class="mb-6 flex items-center justify-between">
    <div class="flex items-center gap-2">
      <LockIcon class="lucide-icon-m text-icon-primary" />
      <div class="text-headline-xs">
        {{ label }}
      </div>
      <TooltipWrapper v-if="helpTooltip">
        <template #trigger>
          <a
            v-if="helpLink"
            :href="helpLink"
            target="_blank"
            @click="trackPlanExplore({ entity_type: entityType, entity_id: entityId, placement })"
            ><CircleHelpIcon class="lucide-icon-s text-icon-subtlest"
          /></a>
          <CircleHelpIcon v-else class="lucide-icon-s text-icon-subtlest" />
        </template>
        <template #content>
          <div class="max-w-xs" @click="onTooltipClick" v-html="helpTooltip"></div>
        </template>
      </TooltipWrapper>
    </div>
    <a
      class="btn-primary-color-s"
      :href="upgradeCtaLink"
      target="_blank"
      data-testid="reviews-fencing-upgrade-cta"
      @click="trackPlanUpgrade({ entity_type: entityType, entity_id: entityId, placement })"
    >
      {{ upgradeCta }}
      <UnlockIcon class="lucide-icon-m text-icon-inverse" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { CircleHelpIcon, LockIcon, UnlockIcon } from '@ramp106/omrjs-core-ui/icons'
import type { EntityType } from '@ramp106/omrjs-tracking-reviews'

import { trackPlanExplore, trackPlanUpgrade } from '@/services/planCtaTracking'

const props = defineProps<{
  label: string
  helpLink?: string
  helpTooltip?: string
  upgradeCta: string
  upgradeCtaLink: string
  placement: string
  entityType: EntityType
  entityId: string
}>()

function onTooltipClick(event: MouseEvent) {
  if ((event.target as HTMLElement).closest('a')) {
    trackPlanExplore({ entity_type: props.entityType, entity_id: props.entityId, placement: props.placement })
  }
}
</script>
